var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodaysontime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Radio Checked Icon 1",
    clipPath: "url(#clip0_531_18945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1113 20.0001C11.1113 15.0881 15.0873 11.1121 19.9993 11.1121C24.9113 11.1121 28.8873 15.0881 28.8873 20.0001C28.8873 24.9121 24.9113 28.8881 19.9993 28.8881C15.0873 28.8881 11.1113 24.9121 11.1113 20.0001Z",
    fill: "#13CFEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 40C31.044 40 40 31.044 40 20C40 8.956 31.044 0 20 0C8.956 0 0 8.956 0 20C0 31.044 8.956 40 20 40ZM20 35.556C11.408 35.556 4.444 28.592 4.444 20C4.444 11.408 11.408 4.444 20 4.444C28.592 4.444 35.556 11.408 35.556 20C35.556 28.592 28.592 35.556 20 35.556Z",
    fill: "#13CFEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_531_18945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodaysontime);
export default __webpack_public_path__ + "static/media/Today’s on time.57e15dce042cafdf268e681564dbc0ad.svg";
export { ForwardRef as ReactComponent };